import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {Divider} from '@vio/atlas/src/components/designSystem/Divider'

const InfoCardSkeleton = () => (
  <Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent="space-between"
    padding="s500"
    borderColor="border.neutral.secondary"
    borderWidth="bw100"
    borderStyle="solid"
    borderRadius="lg"
    flex="1"
  >
    <div>
      <SkeletonLoader width={100} />
      <SkeletonLoader width={140} />
    </div>
  </Box>
)

export const PriceTrendDesktopLoading = () => {
  return (
    <Box data-id="price-trend-desktop-skeleton" paddingBottom="s800">
      <Box paddingTop="s700" paddingBottom="s300">
        <Divider />
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        gap="s300"
        alignItems="center"
        paddingTop="s400"
        marginBottom="s400"
      >
        <Icon name="Sparkles" colorPath="content.brand.primary" />
        <SkeletonLoader width={200} marginTop={0} />
      </Box>
      <Box display="flex" flexDirection="row" gap="s400" marginBottom="s400">
        <InfoCardSkeleton />
        <InfoCardSkeleton />
      </Box>
      <SkeletonLoader />
    </Box>
  )
}
